import React from "react";
import Lottie from "lottie-react";
import animationData from "../../animations/LoadingAnimation.json";

const CANVAS_RATIO = 300 / 66;

interface CircleLoaderProps {
  size?: number;
}

function CircleLoader({ size = 48 }: CircleLoaderProps) {
  return (
    <div className="circle-loader" style={{ width: size, height: size, position: "relative", overflow: "hidden" }}>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: size * CANVAS_RATIO,
          height: (size * CANVAS_RATIO) / 2,
          transform: "translate(-50%, -50%)",
        }}
      >
        <Lottie animationData={animationData} loop />
      </div>
    </div>
  );
}

export default CircleLoader;
